'use client';

import { GA_CONFIG } from '@/lib/analytics/ga-config';
import Script from 'next/script';

// Google Tag Manager Component
export default function GoogleTagManager() {
  // Always render for testing, but you can change this back to production-only if needed
  // if (process.env.NODE_ENV !== 'production') {
  //   return null;
  // }

  return (
    <>
      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GA_CONFIG.GTM_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
      
      {/* Google Tag Manager Script */}
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GA_CONFIG.GTM_ID}');
          `,
        }}
      />
    </>
  );
}
